import { render, staticRenderFns } from "./AbkFormSummaryTable.vue?vue&type=template&id=29926952&scoped=true&"
import script from "./AbkFormSummaryTable.vue?vue&type=script&lang=js&"
export * from "./AbkFormSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./AbkFormSummaryTable.vue?vue&type=style&index=0&id=29926952&scoped=true&lang=scss&"
import style1 from "./AbkFormSummaryTable.vue?vue&type=style&index=1&id=29926952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29926952",
  null
  
)

export default component.exports